import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE =
  "حاسبة طول ضلع المربع - حساب طول ضلع المربع بناءً على المساحة أو المحيط";
const DESCRIPTION =
  "حاسبة طول ضلع المربع تقوم بحساب طول ضلع المربع بناءً على المساحة أو المحيط المدخلين.";
const KEYWORDS = "طول ضلع المربع, حساب طول ضلع المربع, حاسبة طول ضلع المربع";
const OG_URL = "https://do-calculate.com/calculator/ar/square-side-length";
function Calculator() {
  const [perimeter, setPerimeter] = useState("");
  const [area, setArea] = useState("");
  const [sideLength, setSideLength] = useState("");
  const [calculationType, setCalculationType] = useState("perimeter");
  const [error, setError] = useState("");
  const handleCalculationTypeChange = (newCalculationType) => {
    setCalculationType(newCalculationType);
    if (newCalculationType === "perimeter") {
      setArea("");
    }
    if (newCalculationType === "area") {
      setPerimeter("");
    }
  };
  const handleCalculate = () => {
    if ((!perimeter && !area) || (perimeter && area)) {
      setError("الرجاء إدخال إما المساحة أو المحيط فقط");
      setSideLength("");
      return;
    }
    if (calculationType === "perimeter") {
      if (perimeter) {
        const perimeterValue = parseFloat(perimeter);
        if (isNaN(perimeterValue) || perimeterValue <= 0) {
          setError("الرجاء إدخال قيمة صحيحة وموجبة للمحيط");
          setSideLength("");
          return;
        }
        const length = perimeterValue / 4;
        setSideLength(length.toFixed(2));
        setError("");
      }
    } else if (calculationType === "area") {
      if (area) {
        const areaValue = parseFloat(area);
        if (isNaN(areaValue) || areaValue <= 0) {
          setError("الرجاء إدخال قيمة صحيحة وموجبة للمساحة");
          setSideLength("");
          return;
        }
        const length = Math.sqrt(areaValue);
        setSideLength(length.toFixed(2));
        setError("");
      }
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>كيفية حساب طول ضلع المربع</h2>
                <p>
                  يمكن حساب طول ضلع المربع بناءً على المساحة أو المحيط بواسطة
                  القوانين التالية:
                </p>
                <p>إذا كان لديك المحيط: الطول = المحيط / 4</p>
                <p>إذا كان لديك المساحة: الطول = الجذر التربيعي للمساحة</p>
                <p>يجب إدخال إما المساحة أو المحيط فقط لحساب طول ضلع المربع.</p>
                <hr />
              </div>
            </div>
                <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    هل تريد حساب طول الضلع عن طريق المحيط ام المساحة ؟
                    <div className="form-check">
                      <input
                        type="radio"
                        name="calculationType"
                        id="perimeterRadio"
                        value="perimeter"
                        checked={calculationType === "perimeter"}
                        onChange={() =>
                          handleCalculationTypeChange("perimeter")
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="perimeterRadio"
                      >
                        المحيط
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        type="radio"
                        name="calculationType"
                        id="areaRadio"
                        value="area"
                        checked={calculationType === "area"}
                        onChange={() => handleCalculationTypeChange("area")}
                      />
                      <label className="form-check-label" htmlFor="areaRadio">
                        المساحة
                      </label>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">المحيط (سم)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="المحيط"
                        value={perimeter}
                        onChange={(e) => setPerimeter(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                        disabled={calculationType === "area"}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">المساحة (سم²)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="المساحة"
                        value={area}
                        onChange={(e) => setArea(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                        disabled={calculationType === "perimeter"}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب طول ضلع المربع
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {sideLength !== "" && (
                          <p className="p-3 mb-2 bg-success text-white">
                            طول ضلع المربع: {sideLength} سم
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
